<template>
  <v-navigation-drawer
    v-if="lDrawer"
    persistent
    :mini-variant="false"
    v-model="drawer"
    enable-resize-watcher
    fixed
    app
    flat
    class="white"
    width="280"
  >
    <v-container class="pa-0">
      <div class="pa-5">
        <v-img class="mr-auto ml-auto" max-width="40%" src="/img/logo.png" lazy-src="/img/logo.png" contain />
      </div>

      <v-list-item class="">
        <v-list-item-content>
          <v-list-item-title class="caption grey--text">Instansi</v-list-item-title>
          <v-list-item-title class="mt-2 primary--text font-weight-bold">{{
            current_instansi ? current_instansi.nama : ""
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="mx-5"></v-divider>

      <v-row column class="pt-0 mt-0 px-3">
        <v-col cols="12" class="ma-0 pa-0">
          <v-list dense class="fix-icon">
            <div v-for="item in items" :key="item.id ? item.id : item.title" class>
              <template v-if="item.subheader">
                <v-subheader v-if="!item.hidden" class="font-weight-medium subtitle teal--text mx-3">{{
                  item.title
                }}</v-subheader>
              </template>
              <template v-else-if="item.moreActive && !item.hidden">
                <v-list-item class="pt-4" @click="changeDiklat">
                  <v-list-item-content>
                    <v-list-item-title class="primary--text ml-1 ">{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else-if="item.more && !item.hidden">
                <v-divider class="mt-2"></v-divider>
                <v-list-item class="pt-4" @click="moreDiklat">
                  <v-list-item-title class="grey--text">Diklat Sebelumnya</v-list-item-title>
                  <v-list-item-icon>
                    <v-icon class="mr-0 grey--text">{{ moreItem ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </template>
              <template v-else-if="item.items">
                <v-list-group
                  class="my-act-icon mx-0 primary--text ml-2"
                  v-if="!item.hidden"
                  v-model="item.active"
                  :prepend-icon="item.icon"
                  no-action
                >
                  <template v-slot:activator>
                    <v-list-item-content
                      class="primary-text"
                      v-if="item.items"
                      :key="item.id ? item.id : item.title"
                      exact
                    >
                      <v-list-item-title class="primary--text" style="white-space: normal;">{{
                        item.title
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-for="subItem in item.items" class="primary--text">
                    <v-list-item
                      class="mx-0"
                      v-if="!subItem.hidden"
                      :key="subItem.id ? subItem.id : subItem.title"
                      :to="subItem.to"
                      :href="subItem.href"
                      exact
                    >
                      <v-list-item-title v-if="subItem.demo" class="primary--text">
                        <v-badge color="error" content="demo">{{ subItem.title }}</v-badge>
                      </v-list-item-title>
                      <v-list-item-title v-else class="mr-0 primary--text">{{ subItem.title }}</v-list-item-title>
                      <v-list-item-action v-if="subItem.icon" class="primary--text mr-0">
                        <v-icon class="mr-0 primary--text">{{ subItem.icon }}</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list-group>
              </template>
              <template v-else>
                <v-list-item
                  class="my-3 secondary--text"
                  v-if="!item.hidden"
                  :key="item.id ? item.id : item.title"
                  :to="item.to"
                  :href="item.href"
                  active-class="my-active-link"
                  exact
                >
                  <v-list-item-action class="my-act-icon ml-1 mr-3 ma-0">
                    <v-icon :color="item.to.name == $route.name ? 'secondary' : 'primary'">{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content class="mr-0">
                    <v-list-item-title v-if="item.demo">
                      <v-badge color="error" content="demo">{{ item.title }}</v-badge>
                    </v-list-item-title>
                    <v-list-item-title
                      :class="item.to.name == $route.name ? 'secondary--text' : 'primary--text'"
                      v-else
                      >{{ item.title }}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
            </div>
          </v-list>
          <!-- </v-row> -->
          <v-list>
            <v-list-item class="primary--text" @click="toSIMPKB()">
              <v-list-item-action class="mr-4">
                <v-icon class="primary--text mr-0">mdi-desktop-mac</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primary--text font-weight-bold" style="font-size:13px"
                  >Halaman SIM</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
    <PilihInstansi ref="dlg" />
    <PilihDiklat ref="dlgDiklat" />
  </v-navigation-drawer>
</template>

<script>
import { SIMPKB } from "@/const";
import MListGroup from "./MListGroup";
import MListTile from "./MListTile";
import PilihInstansi from "../modules/instansi/components/PilihInstansiDialog";
import PilihDiklat from "../modules/diklat/components/PilihDiklatDialog";
// const lc = window.localStorage;
// const DiklatTerpilih = "DiklatTerpilih";
export default {
  components: {
    MListGroup,
    MListTile,
    PilihInstansi,
    PilihDiklat
  },
  data() {
    return {
      drawer: this.lDrawer,
      moreItem: false
      // items: []
    };
  },
  computed: {
    lDrawer() {
      return this.$store.getters["main/lDrawer"];
    },
    items() {
      // if (!this.moreItem) {
      //   return this.$store.getters["menu/menus"];
      // } else {
      //   return this.$store.getters["menu/moreMenus"];
      // }
      return this.$store.getters["menu/menus"];
    }
  },
  methods: {
    loadItems() {
      this.items = this.$store.getters["menu/menus"];
    },
    toSIMPKB() {
      window.open(SIMPKB, "_blank");
    },
    changeDiklat() {
      this.$refs.dlgDiklat
        .open()

        .then(() => {
          this.items;
        })
        .catch(e => e);
    },
    moreDiklat() {
      this.moreItem = !this.moreItem;
    }
  },
  watch: {
    instansi_id() {
      // this.loadItems();
    },
    lDrawer(n) {
      this.drawer = n;
      // this.loadItems();
    },
    drawer(n) {
      this.$store.commit("main/setLDrawer", n);
    }
  }
};
</script>

<style>
.fix-icon .v-icon.fas {
  font-size: 1rem !important;
}
.fix-icon .my-act-icon .v-icon,
.fix-icon .v-list__group__header__prepend-icon .v-icon {
  font-size: 20px !important;
}
.fix-icon .my-act-icon,
.fix-icon .v-list__group__header .v-list__group__header__prepend-icon {
  padding-right: 0;
  min-width: 25px;
}
.fix-icon .v-list__group__items .v-list__tile {
  padding-left: 56px !important;
}
.fix-icon .my-active-link {
  color: #fff !important;
  background-color: #fef2f2;
}
.fix-icon .link {
  color: #fff !important;
}
</style>
